import { SUPPORTED_LANGUAGES, useLang } from '@inflearn/i18n-tools';
import { merge } from 'lodash-es';
import queryString from 'query-string';
import { useMemo } from 'react';

import {
  API_ENDPOINT,
  type ClientApiV1GuidesQueryString,
  useClientApiV1GuidesQuery,
} from '../../resources/@types/accountSchema';
import { HAS_GUIDE_LANG } from '../utils/i18n/hasGuideLang';

const isPartners = (type: ClientApiV1GuidesQueryString['type']) => {
  return (
    type === 'MARKETING_PARTNERS_TERMS' ||
    type === 'MARKETING_PARTNERS_POLICY' ||
    type === 'MARKETING_PARTNERS_GUIDE'
  );
};

function useClientGuidesQuery(
  guidesQueryString: ClientApiV1GuidesQueryString,
  options?: Parameters<typeof useClientApiV1GuidesQuery>[0]['options'],
) {
  const { isKo, lang } = useLang();

  const guideLanguage = useMemo(() => {
    if (HAS_GUIDE_LANG.includes(lang)) {
      return lang;
    }

    if (isKo) {
      return SUPPORTED_LANGUAGES.ko;
    }

    return SUPPORTED_LANGUAGES.en;
  }, [lang, isKo]);

  return useClientApiV1GuidesQuery({
    queryKey: getGuidesQueryKey(guidesQueryString),
    url: `${API_ENDPOINT.CLIENT_V1_GUIDES}?${queryString.stringify(
      merge({ lang: isPartners(guidesQueryString.type) ? lang : guideLanguage }, guidesQueryString),
    )}`,
    options,
  });
}

export const getGuidesQueryKey = (guidesQueryString: ClientApiV1GuidesQueryString) => [
  API_ENDPOINT.CLIENT_V1_GUIDES,
  guidesQueryString,
];

export default useClientGuidesQuery;
